export default __webpack_public_path__ + "static/media/shivam raj.75c1b8ab.jpeg";